import { Logger } from "../../helpers/Logger";
import { EVENTS, getTrackingId } from "../config/CONSTANTS";

/**
 * @fileoverview Handles tracking events with Pinterest Pixel.
 * @module PinterestPixel
 */

/**
 * Tracks an event and sends data to Pinterest Pixel.
 * Initializes the pixel if not already initialized.
 *
 * ### Allowed Event Types and Data
 * - Common event types: `PageVisit`, `ViewCategory`, `Search`, `AddToCart`, `Checkout`, `WatchVideo`, etc.
 * - `eventData` can include properties like `product_name`, `product_category`, `search_query`, etc.
 *
 * @example
 * trackPinterestPixelEvent('PageVisit', { product_name: 'Red Dress' });
 *
 * @param {string} eventType - The type of event to track.
 * @param {Object} eventData - The data to send with the event.
 */
export function trackPinterestPixelEvent(eventType, eventData) {
  // Define a mapping for non-standard event names to standard ones
  const eventMapping = {
    'PageView': 'PageVisit', // Use 'PageVisit' for general page views
    'Contact': 'lead', // Contact Us Form
    'FindLocation': 'search', // View Store Locator Page
    'Subscribe': 'signup', // Newsletter
    'ViewContent': 'ViewContent', // Pinterest doesn't support this yet.
};

  // Map the eventType to a standard event name if it exists in the mapping, otherwise use the original
  const mappedEventType = eventMapping[eventType] || eventType;

  function initPixel() {
    if (typeof window === "undefined") return;

    if (window.pintrk && window.pintrk.loaded) return;

    !(function (e) {
      if (!window.pintrk) {
        window.pintrk = function () {
          window.pintrk.queue.push(Array.prototype.slice.call(arguments));
        };
        var n = window.pintrk;
        (n.queue = []), (n.version = "3.0");
        var t = document.createElement("script");
        (t.async = !0), (t.src = e);
        var r = document.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(t, r);
      }
    })("https://s.pinimg.com/ct/core.js");

    pintrk("load", getTrackingId("Pinterest_Pixel"));
    pintrk("page");
    if(window.pintrk){
      window.pintrk.loaded = true;
    }

  }

  initPixel();

  if ( window.pintrk ) {
    try {
      pintrk("track", mappedEventType, eventData);
      Logger.log(`Pinterest Pixel event sent: ${mappedEventType}`, eventData);
    } catch (error) {
      Logger.error("Error sending Pinterest Pixel event:", error);
    }
  } else {
    Logger.error("Pinterest Pixel not loaded");
  }
}

// Example usage (if needed)

// Simulate a delay for testing purposes
// setTimeout(() => {
//   trackPinterestPixelEvent('PageVisit', { product_name: 'Example Product' });
// }, 200);

// trackPinterestPixelEvent('AddToCart', { product_id: '123', product_name: 'Test Product' });